<template>
  <div class="main">
    <div class="header-top-c">
      <!--       <p class="breadcrumb hidden-xs">
        <span v-for="m in $route.matched" :key="m.id">
          <router-link :to="{path:m.path}">{{m.meta.title}}  </router-link>
        </span>
      </p> -->
      <ol class="breadcrumb hidden-xs">
        <li v-for="m in $route.matched" :key="m.id">
           <router-link :to="{path:m.path}">{{m.meta.title}} > </router-link>
        </li>
      </ol>
      <span class="page-title" v-if="$route.meta.title"> {{$route.meta.title}}</span>
    </div>
    <div class="sysContent">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datalists: {}
    }
  },
  created() {
    // console.log(this.$route.matched)
  }
}

</script>
<style lang="stylus" scoped>
.main {
  position: relative;
  min-height: 100%;
  zoom: 1;
  .header-top-c {
  	display: none;
    height: 10px;
    line-height: 10px;
    .breadcrumb {
      text-align: left;
      a {
        color: #a8a8aa;
        font-size: 14px;
      }
    }
  }
  .sysContent {
  	margin-top: 15px;;
    background: #fff;
    min-height: 714px;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
    text-indent: none;
    margin-bottom: 90px;
  }
}

.breadcrumb {
  padding: 0 0 0 0!important;
  li {
    float: left
  }
}

.breadcrumb>li+li:before {
  display: none;
}
.breadcrumb li:first-child {
  display: none;
}
.breadcrumb li:last-child {
  display: none;
}
.page-title {
  margin-left: 3px;
  color: #a8a8aa;
  font-size: 14px;
}
i{
  font-style:normal
}
</style>



// WEBPACK FOOTER //
// Content.vue?2c40b7a6